import React from 'react';

/**
 * DataCard - Content card with consistent padding and shadow
 * Used for wrapping sections of content
 */
export const DataCard = ({ 
  title, 
  subtitle,
  actions,
  children, 
  className = '',
  padding = 'p-6'
}) => {
  return (
    <div className={`bg-white rounded-xl border border-gray-200 shadow-sm ${className}`}>
      {(title || subtitle || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-6 pt-6 pb-4 border-b border-gray-200">
          <div>
            {title && (
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            )}
            {subtitle && (
              <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </div>
      )}
      <div className={padding}>
        {children}
      </div>
    </div>
  );
};

export default DataCard;
